import React, { useContext } from 'react';
import coreLogo from '../../assets/core.jpg';
import { ButtonBase } from '@material-ui/core';
import { observer } from 'mobx-react-lite';
import { useHistory, useLocation } from 'react-router-dom';
import { GlobalsContext } from '../../store/Globals';
import {
  Icon,
  Container,
  Typography,
  BackButtonContainer,
  ReloadButtonContainer,
} from './styles';

const Header = observer(() => {
  const globals = useContext(GlobalsContext);
  const history = useHistory();
  const location = useLocation();
  const { definitions, headerHeight } = globals;
  const { orgMSP, colors } = definitions;

  return (
    <Container colors={colors as string[]} height={headerHeight}>
      <div>
        <ButtonBase onClick={() => globals.setDrawerOpen(true)}>
          <Icon overridecolor={colors[2]} className="bx bx-menu" />
        </ButtonBase>

        <BackButtonContainer
          onClick={() => {
            if (location.pathname !== '/') {
              history.goBack();
            }
          }}
        >
          <Icon overridecolor={colors[2]} className="bx bx-arrow-back" />
        </BackButtonContainer>
        <ReloadButtonContainer
          onClick={() => {
            window.location.reload();
          }}
        >
          <Icon overridecolor={colors[2]} className="bx bx-refresh" />
        </ReloadButtonContainer>
        <ButtonBase onClick={() => globals.setConfigServer(true)}>
          <Icon overridecolor={colors[2]} className="bx bx-cog" />
        </ButtonBase>
        <ButtonBase onClick={() => {
          globals.clearAuth();
          window.location.reload();
        }}>
          <Icon overridecolor={colors[2]} className="bx bx-log-out" />
        </ButtonBase>
      </div>

      <ButtonBase onClick={() => {
        if (location.pathname !== '/') {
          history.push('/');
        }
      }}>
        <Typography overridecolor={colors[2]}>
          {globals.currentOrganization?.name || orgMSP.replace('MSP', '')}
        </Typography>
      </ButtonBase>

      <ButtonBase
        onClick={() => {
          window.location.reload();
        }}
        style={{ padding: '1%' }}
      >
        <img
          src={coreLogo}
          alt="Core logo"
          style={{ zIndex: 1001, height: '45px' }}
        />
      </ButtonBase>
    </Container>
  );
});

export default Header;
